import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "9f16e4e1-5e9f-4ff5-9b2e-dfa081e46914"
// title: "Join Us Page"
// type: :reference
// key: "join-us-page"
// parent_id: nil
export function JoinUsPage9f16e4e15e9f4ff59b2eDfa081e46914(props: any) {
  return (
    <SecondaryPage27f579b5D62946a5839a850b9f70f2bd parentTag="JoinUsPage9f16e4e15e9f4ff59b2eDfa081e46914" header={<SecondaryMarketingHeader8aca20333265438fAc457e9bd43ceea1 parentTag="Header669c6d639d2f4fd9B0b9A5dd2189f6cd" title="Join Us" />} {...props} />
  );
}

// id: "9326855f-d3ca-4792-b28c-5065a9d16982"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter9326855fD3ca4792B28c5065a9d16982(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter9326855fD3ca4792B28c5065a9d16982 footer`}>
      <div className="logo-wrapper">
        {props["logo"] || <LogoDf977f0dC0a145c08d69A193005d293b />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright15533833F338497fBe7a74e9aaa1e22b" parentTag={buildClassName("Copyright15533833F338497fBe7a74e9aaa1e22b", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="GroupflowB068410bB6c54631953b0ab88ec3623c" parentTag={buildClassName("GroupflowB068410bB6c54631953b0ab88ec3623c", parentTag)} {...props} />}
    </footer>
  );
}

// id: "4f01a463-58a1-4008-85bd-18a1e1002168"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "10caabd7-4a35-43fa-a8a0-3cc87e25f717"
export function Footer4f01a46358a1400885bd18a1e1002168(props: any) {
  return (
    <DefaultFooter9326855fD3ca4792B28c5065a9d16982 parentTag="Footer4f01a46358a1400885bd18a1e1002168" {...props} />
  );
}

// id: "f4ff8cd0-9459-4d85-a721-d73c53c8cf40"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "8aca2033-3265-438f-ac45-7e9bd43ceea1"
export function HeroF4ff8cd094594d85A721D73c53c8cf40(props: any) {
  return (
    <SecondaryMarketingHero0b4bf3ff55b6475aA1025ac8cdfb8f84 parentTag="HeroF4ff8cd094594d85A721D73c53c8cf40" title="Secondary Marketing Title 2" {...props} />
  );
}

// id: "6a1db0e5-69ca-4821-b004-a6ef5a1d65f7"
// title: "join-omen"
// type: :html
// key: "join-omen"
// parent_id: "0082cffe-f5be-4f23-b1b1-679f420360e8"
export function JoinOmen6a1db0e569ca4821B004A6ef5a1d65f7(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <section className={`${parentTag || ""} JoinOmen6a1db0e569ca4821B004A6ef5a1d65f7`}>
      <div className="omen-container-main">
        <h1 className="omen-container-heading">
          Why Join OMEN?
        </h1>
        <div className="omen-grid-container">
          <div className="omen-grid-item">
            <div>
              <img src="https://mp1md-pub.s3-us-west-2.amazonaws.com/content/1OEb72KdzLf1GZsp_file.svg" alt="Icon 1" />
            </div>
            <div>
              <h3>
                Private Group Of Oregon Men Enjoying Naturism
              </h3>
              <p>
                Connect with other friendly naked men via our various organized activities and form great camaraderie.
              </p>
            </div>
          </div>
          <div className="omen-grid-item">
            <div>
              <img src="https://mp1md-pub.s3-us-west-2.amazonaws.com/content/ygyvuTtS_-VOoNM2_file.svg" alt="Icon 2" />
            </div>
            <div>
              <h3>
                Inclusivity
              </h3>
              <p>
                Open to age-appropriate gay/bi, and trans men of all races, colors, religions, physical disabilities, and ethnic or national origins.
              </p>
            </div>
          </div>
          <div className="omen-grid-item">
            <div>
              <img src="https://mp1md-pub.s3-us-west-2.amazonaws.com/content/xWQBrnOuGSsf8rnm_file.svg" alt="Icon 3" />
            </div>
            <div>
              <h3>
                Monthly Activities And Events
              </h3>
              <p>
                Each month we offer social potlucks, dances, karaoke nights, pool parties, spa nights, camping weekends, themed events, and much more.
              </p>
            </div>
          </div>
          <div className="omen-grid-item">
            <div>
              <img src="https://mp1md-pub.s3-us-west-2.amazonaws.com/content/8FANX31Ya6YXkRRv_file.svg" alt="Icon 4" />
            </div>
            <div>
              <h3>
                No Shaming Policy
              </h3>
              <p>
                We&#39;re regular men, not models and whatever your issue may be, someone else will be larger, smaller, balder, so just be yourself and join us!
              </p>
            </div>
          </div>
          <div className="omen-grid-item">
            <div>
              <img src="https://mp1md-pub.s3-us-west-2.amazonaws.com/content/L5Igdk4e3i6zUwUg_file.svg" alt="Icon 5" />
            </div>
            <div>
              <h3>
                Exclusive Discounts
              </h3>
              <p>
                Save money on spa nights, food, and beverages from our recommended partners and get access to exclusive offers.
              </p>
            </div>
          </div>
          <div className="omen-grid-item">
            <div>
              <img src="https://mp1md-pub.s3-us-west-2.amazonaws.com/content/lW595gIuA-dC63tv_file.svg" alt="Icon 6" />
            </div>
            <div>
              <h3>
                Member Driven Organization
              </h3>
              <p>
                We are not a business venture. Most of our gatherings are in private residences and camping on private, member-owned land.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// id: "418f4997-10dc-40c9-9ca8-9a38fb06a750"
// title: "more-questions"
// type: :html
// key: "more-questions"
// parent_id: "0082cffe-f5be-4f23-b1b1-679f420360e8"
export function MoreQuestions418f499710dc40c99ca89a38fb06a750(props: any) {
  const Link = AppStore.presets["Link"];
  const Button = AppStore.presets["Button"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <section className={`${parentTag || ""} MoreQuestions418f499710dc40c99ca89a38fb06a750 faq-section`}>
      <div className="faq-main-container">
        <h2>
          FAQs
        </h2>
        <h3>
          Have More Questions?
        </h3>
        <details>
          <summary>
            How Big Is The Community?
          </summary>
          <p>
            The OMEN community has over 260 active members and we are growing each month.
          </p>
        </details>
        <details>
          <summary>
            Where Are The Members Located?
          </summary>
          <p>
            Our members are located in Oregon, Washington and many other states.
          </p>
        </details>
        <details>
          <summary>
            Who Should Not Apply?
          </summary>
          <p>
            All our events are completely naked. We are not a clothing optional group, and if you are uncomfortable with this you should not apply.
          </p>
        </details>
        <details>
          <summary>
            Is There An Age Limit?
          </summary>
          <p>
            Members must be at least 21 years old to join OMEN.
          </p>
        </details>
        <details>
          <summary>
            What Kind Of Discounts Are Available?
          </summary>
          <p>
            We offer a variety of discounts to our members from our partners in the Portland Vancouver metro area.
          </p>
        </details>
        <details>
          <summary>
            Can I Host An Event?
          </summary>
          <p>
            Yes, members can apply and request to host nude events after fulfilling certain criteria.
          </p>
        </details>
        <div className="buttons">
          {props["join-button"] || <Link className="JoinButton8a7436d257574a1b8a72Dec2de484fc3" parentTag={buildClassName("JoinButton8a7436d257574a1b8a72Dec2de484fc3", parentTag)} href="/join" label="Become A Member" className="member-btn transition" {...props} />}
          {props["events-button"] || <Button className="EventsButtonDbd7cab6291146fbAa61766d45ee432d" parentTag={buildClassName("EventsButtonDbd7cab6291146fbAa61766d45ee432d", parentTag)} href="/events/public" className="events-btn secondary transition" label="View Upcoming Events" {...props} />}
        </div>
      </div>
    </section>
  );
}

// id: "6d644d16-a544-45e2-9aa2-7225b2564b14"
// title: "Public Events Page"
// type: :html
// key: "public-events-page"
// parent_id: nil
export function PublicEventsPage6d644d16A54445e29aa27225b2564b14(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicEventsPage6d644d16A54445e29aa27225b2564b14`}>
      {props["header"] || <SecondaryMarketingHeader8aca20333265438fAc457e9bd43ceea1 parentTag="HeaderAea49ec26e964bdfB267Cad9c6ec51ce" title="Public Events" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter9326855fD3ca4792B28c5065a9d16982 parentTag="Footer3c24d4b730c94e44B3070b28451ef3b7" {...props} />}
    </div>
  );
}

// id: "0eb0fc95-12ed-4240-86fe-8bae2600e8fc"
// title: "Members Area"
// type: :html
// key: "members-area-default"
// parent_id: nil
export function MembersAreaDefault0eb0fc9512ed424086fe8bae2600e8fc(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MembersAreaDefault0eb0fc9512ed424086fe8bae2600e8fc page`}>
      {props["header"] || <MembersAreaHeader972591a7Ba0146708e4fC1b376bff0d2 parentTag="Header28c59e43D7f0406e8acf07f97526a936" navMenuSlug="members-primary-nav" {...props} />}
      {props["footer"] || <DefaultFooter9326855fD3ca4792B28c5065a9d16982 parentTag="Footer2158ad416a64442bBc6e4342bc1dd973" {...props} />}
    </div>
  );
}

// id: "ef184ce6-1147-4632-9c16-8f0ce645e8da"
// title: ""
// type: :reference
// key: "body"
// parent_id: "d162191f-8aee-46d8-b4e8-a81e9a91bbf4"
export function BodyEf184ce6114746329c168f0ce645e8da(props: any) {
  return (
    <MarketingBodyA39ef99c319842569fd8Bb1e1500cfb1 parentTag="BodyEf184ce6114746329c168f0ce645e8da" postSlug="about-us-posts" {...props} />
  );
}

// id: "0082cffe-f5be-4f23-b1b1-679f420360e8"
// title: ""
// type: :html
// key: "body"
// parent_id: "296811eb-88ab-4b58-91b5-0fe7d26b7ec7"
export function Body0082cffeF5be4f23B1b1679f420360e8(props: any) {
  const Button = AppStore.presets["Button"];
  const Link = AppStore.presets["Link"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <section className={`${parentTag || ""} Body0082cffeF5be4f23B1b1679f420360e8`}>
      {props["join-omen"] || <JoinOmen6a1db0e569ca4821B004A6ef5a1d65f7 />}
      {props["omen-image-gallery"] || <OmenImageGallery70c25caf152e48eaBbf752f033c4779a />}
      {props["our-story"] || <OurStoryEa06bfc1C12b41f59560C587c0f175a0 />}
      {props["more-questions"] || <MoreQuestions418f499710dc40c99ca89a38fb06a750 />}
    </section>
  );
}

// id: "ee238e6d-d804-4e66-9ed2-1f096bcbcd71"
// title: "Logo"
// type: :html
// key: "default-logo"
// parent_id: nil
export function DefaultLogoEe238e6dD8044e669ed21f096bcbcd71(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3-us-west-2.amazonaws.com/content/qD9ySvYVxmpqtVP1_regular.png" className={`${parentTag || ""} DefaultLogoEe238e6dD8044e669ed21f096bcbcd71 logo`} alt="logo" />
  );
}

// id: "c2b9633b-d80c-49f6-af8f-b3970bdb7529"
// title: "Marketing Cards"
// type: :gf_preset
// key: "marketing-cards"
// parent_id: nil
export function MarketingCardsC2b9633bD80c49f6Af8fB3970bdb7529(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="MarketingCardsC2b9633bD80c49f6Af8fB3970bdb7529" parentTag={buildClassName("MarketingCardsC2b9633bD80c49f6Af8fB3970bdb7529", parentTag)} postSlug="home-page-posts2" buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" {...props} />
  );
}

// id: "15533833-f338-497f-be7a-74e9aaa1e22b"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "9326855f-d3ca-4792-b28c-5065a9d16982"
export function Copyright15533833F338497fBe7a74e9aaa1e22b(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright15533833F338497fBe7a74e9aaa1e22b" parentTag={buildClassName("Copyright15533833F338497fBe7a74e9aaa1e22b", parentTag)} {...props} />
  );
}

// id: "28c59e43-d7f0-406e-8acf-07f97526a936"
// title: ""
// type: :reference
// key: "header"
// parent_id: "0eb0fc95-12ed-4240-86fe-8bae2600e8fc"
export function Header28c59e43D7f0406e8acf07f97526a936(props: any) {
  return (
    <MembersAreaHeader972591a7Ba0146708e4fC1b376bff0d2 parentTag="Header28c59e43D7f0406e8acf07f97526a936" navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "bee4ad69-9935-4271-9731-b5bcda270557"
// title: ""
// type: :text
// key: "url"
// parent_id: "bfa4bb1c-af41-4971-98ca-5d272fa5622f"
export const UrlBee4ad69993542719731B5bcda270557 = "/";

// id: "1d596b75-1d30-4128-9166-792793475e8d"
// title: ""
// type: :text
// key: "title"
// parent_id: "f4ff8cd0-9459-4d85-a721-d73c53c8cf40"
export const Title1d596b751d3041289166792793475e8d = "Secondary Marketing Title 2";

// id: "69e2f3d5-2d6e-4223-833d-033d72afd40e"
// title: "Title - Leveling"
// type: :text
// key: "title"
// parent_id: nil
export const Title69e2f3d52d6e4223833d033d72afd40e = "Leveling";

// id: "972591a7-ba01-4670-8e4f-c1b376bff0d2"
// title: "Members Area Header"
// type: :reference
// key: "members-area-header"
// parent_id: nil
export function MembersAreaHeader972591a7Ba0146708e4fC1b376bff0d2(props: any) {
  return (
    <ShortHeader4f9e97bdF7ba4870A66bFb3d80b38096 parentTag="MembersAreaHeader972591a7Ba0146708e4fC1b376bff0d2" header-top={<DefaultHeaderTopE752d40187ea4ded95fb0e765a721acd parentTag="HeaderTopEa6fb991D544464bB8da147317734448" navMenuSlug="members-primary-nav" />} {...props} />
  );
}

// id: "dcdb56ad-5f66-41b7-999f-474c9cbf04c6"
// title: ""
// type: :text
// key: "title"
// parent_id: "8aca2033-3265-438f-ac45-7e9bd43ceea1"
export const TitleDcdb56ad5f6641b7999f474c9cbf04c6 = "Secondary Marketing Title 1";

// id: "be8b8123-3d17-4552-90cb-ce46f853f719"
// title: ""
// type: :text
// key: "title"
// parent_id: "0b4bf3ff-55b6-475a-a102-5ac8cdfb8f84"
export const TitleBe8b81233d17455290cbCe46f853f719 = "Default Title";

// id: "4164aaa7-62d5-42a9-a511-ed995d2beeac"
// title: ""
// type: :text
// key: "title"
// parent_id: "8655273e-2de4-4f44-aaf4-07a8d3e2cd28"
export const Title4164aaa762d542a9A511Ed995d2beeac = "Resources";

// id: "caa59f37-7903-4987-b314-cc0e7cfa1d1f"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "434c22a8-57f7-4c7a-8aeb-539fc915a2e1"
export const PostSlugCaa59f3779034987B314Cc0e7cfa1d1f = "home-hero";

// id: "296811eb-88ab-4b58-91b5-0fe7d26b7ec7"
// title: "Home Page"
// type: :html
// key: "home-page"
// parent_id: nil
export function HomePage296811eb88ab4b5891b50fe7d26b7ec7(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePage296811eb88ab4b5891b50fe7d26b7ec7 page`}>
      {props["header"] || <HomeHeader72b710e6Acf64d1d8a2394268d09b1b3 parentTag="Header565dfaa031ea427787c49d6c83a5380a" {...props} />}
      {props["welcome-back"] || <WelcomeBackPopUp className="WelcomeBack8acea69541a041cc8366F2c7f577444a" parentTag={buildClassName("WelcomeBack8acea69541a041cc8366F2c7f577444a", parentTag)} {...props} />}
      {props["body"] || <Body0082cffeF5be4f23B1b1679f420360e8 />}
      {props["footer"] || <DefaultFooter9326855fD3ca4792B28c5065a9d16982 parentTag="Footer1b4f57e24d274255B6e72c2e51c43706" {...props} />}
    </div>
  );
}

// id: "d2e433f9-95ec-4f2d-9606-b016934ee952"
// title: "WhyOmen"
// type: :html
// key: "why-omen"
// parent_id: nil
export function WhyOmenD2e433f995ec4f2d9606B016934ee952(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} WhyOmenD2e433f995ec4f2d9606B016934ee952 omen-container`}>
      <h1>
        Why Join OMEN?
      </h1>
      <div className="omen-grid-container">
        <div className="omen-grid-item">
          <img src="file-9zs00Ix3ublJ2GcWgwjepT7w" alt="Icon 1" />
          <h3>
            Private Group Of Oregon Men Enjoying Naturism
          </h3>
          <p>
            Connect with other friendly naked men via our various organized activities and form great
            camaraderie.
          </p>
        </div>
        <div className="omen-grid-item">
          <img src="file-9zs00Ix3ublJ2GcWgwjepT7w" alt="Icon 2" />
          <h3>
            Inclusivity
          </h3>
          <p>
            Open to age-appropriate gay/bi men of all races, colors, religions, physical disabilities, and
            ethnic or national origins.
          </p>
        </div>
        <div className="omen-grid-item">
          <img src="file-9zs00Ix3ublJ2GcWgwjepT7w" alt="Icon 3" />
          <h3>
            Monthly Activities And Events
          </h3>
          <p>
            Each month we offer social potlucks, dances, karaoke nights, pool parties, spa nights, camping
            weekends, themed events, and much more.
          </p>
        </div>
        <div className="omen-grid-item">
          <img src="file-9zs00Ix3ublJ2GcWgwjepT7w" alt="Icon 4" />
          <h3>
            No Shaming Policy
          </h3>
          <p>
            We&#39;re regular men, not models and whatever your issue may be, someone else will be larger,
            smaller, balder, so just be yourself and join us!
          </p>
        </div>
        <div className="omen-grid-item">
          <img src="file-9zs00Ix3ublJ2GcWgwjepT7w" alt="Icon 5" />
          <h3>
            Exclusive Discounts
          </h3>
          <p>
            Save money on spa nights, food, and beverages from our recommended partners and get access to
            exclusive offers.
          </p>
        </div>
        <div className="omen-grid-item">
          <img src="file-9zs00Ix3ublJ2GcWgwjepT7w" alt="Icon 6" />
          <h3>
            Member Driven Organization
          </h3>
          <p>
            We are not a business venture. Most of our gatherings are in private residences and camping on
            private, member-owned land.
          </p>
        </div>
      </div>
    </div>
  );
}

// id: "2c859f35-76db-48db-bc8e-bbb2f01da881"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "4f9e97bd-f7ba-4870-a66b-fb3d80b38096"
export function LinkedLogo2c859f3576db48dbBc8eBbb2f01da881(props: any) {
  const Link = AppStore.presets["Link"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo2c859f3576db48dbBc8eBbb2f01da881" parentTag={buildClassName("LinkedLogo2c859f3576db48dbBc8eBbb2f01da881", parentTag)} label={<DefaultLogoEe238e6dD8044e669ed21f096bcbcd71 parentTag="Label5c135844153f4ff9A3a13f6576fad55d" alt="logo" />} {...props} />
  );
}

// id: "aea49ec2-6e96-4bdf-b267-cad9c6ec51ce"
// title: ""
// type: :reference
// key: "header"
// parent_id: "6d644d16-a544-45e2-9aa2-7225b2564b14"
export function HeaderAea49ec26e964bdfB267Cad9c6ec51ce(props: any) {
  return (
    <SecondaryMarketingHeader8aca20333265438fAc457e9bd43ceea1 parentTag="HeaderAea49ec26e964bdfB267Cad9c6ec51ce" title="Public Events" {...props} />
  );
}

// id: "6ef79ca8-08de-4e78-bf56-28d00eb00618"
// title: ""
// type: :text
// key: "subType"
// parent_id: "b4c1c06f-744d-426f-809c-dafa48a3bf1d"
export const SubType6ef79ca808de4e78Bf5628d00eb00618 = "page";

// id: "5c135844-153f-4ff9-a3a1-3f6576fad55d"
// title: ""
// type: :reference
// key: "label"
// parent_id: "2c859f35-76db-48db-bc8e-bbb2f01da881"
export function Label5c135844153f4ff9A3a13f6576fad55d(props: any) {
  return (
    <DefaultLogoEe238e6dD8044e669ed21f096bcbcd71 parentTag="Label5c135844153f4ff9A3a13f6576fad55d" {...props} />
  );
}

// id: "94eed9ff-828d-4e6d-b08c-bbaa13d13a01"
// title: "Common Footer"
// type: :reference
// key: "footer"
// parent_id: nil
export function Footer94eed9ff828d4e6dB08cBbaa13d13a01(props: any) {
  return (
    <DefaultFooter9326855fD3ca4792B28c5065a9d16982 parentTag="Footer94eed9ff828d4e6dB08cBbaa13d13a01" {...props} />
  );
}

// id: "27f579b5-d629-46a5-839a-850b9f70f2bd"
// title: "Secondary Page"
// type: :html
// key: "secondary-page"
// parent_id: nil
export function SecondaryPage27f579b5D62946a5839a850b9f70f2bd(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryPage27f579b5D62946a5839a850b9f70f2bd`}>
      {props["header"] || <SecondaryMarketingHeader8aca20333265438fAc457e9bd43ceea1 parentTag="Header25450764Fa7b4f47A31b94bff0c310c8" title="Secondary Page" {...props} />}
      <div className="text-content">
        {props.children}
      </div>
      {props["footer"] || <DefaultFooter9326855fD3ca4792B28c5065a9d16982 parentTag="FooterA76cb76772a943acBf0dF174671cee77" {...props} />}
    </div>
  );
}

// id: "924d6984-56c7-48d0-894b-ee39094f1af9"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "72b710e6-acf6-4d1d-8a23-94268d09b1b3"
export function HeaderTop924d698456c748d0894bEe39094f1af9(props: any) {
  return (
    <DefaultHeaderTopE752d40187ea4ded95fb0e765a721acd parentTag="HeaderTop924d698456c748d0894bEe39094f1af9" {...props} />
  );
}

// id: "678ea6e8-bfb5-4fca-b23a-4e97f71b84d1"
// title: ""
// type: :gf_preset
// key: "secondary-nav"
// parent_id: "cec4bc13-e390-4eb5-ae0c-2027c80ad748"
export function SecondaryNav678ea6e8Bfb54fcaB23a4e97f71b84d1(props: any) {
  const SecondaryNavigation = AppStore.presets["SecondaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <SecondaryNavigation className="SecondaryNav678ea6e8Bfb54fcaB23a4e97f71b84d1" parentTag={buildClassName("SecondaryNav678ea6e8Bfb54fcaB23a4e97f71b84d1", parentTag)} {...props} />
  );
}

// id: "875ec4da-61f3-4db7-8124-71c90491003d"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "0c5a788d-b105-4d62-b626-7d86f83f2715"
export const ContentSlug875ec4da61f34db7812471c90491003d = "home-page-quote";

// id: "901dbaa6-2733-45ec-82a8-b0b3a9eea3bc"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "28c59e43-d7f0-406e-8acf-07f97526a936"
export const NavMenuSlug901dbaa6273345ec82a8B0b3a9eea3bc = "members-primary-nav";

// id: "31faccfd-bcef-4475-b2c1-d641bdc1b0f8"
// title: "Default Header Reference"
// type: :reference
// key: "default-header"
// parent_id: nil
export function DefaultHeader31faccfdBcef4475B2c1D641bdc1b0f8(props: any) {
  return (
    <ShortHeader4f9e97bdF7ba4870A66bFb3d80b38096 parentTag="DefaultHeader31faccfdBcef4475B2c1D641bdc1b0f8" navMenuSlug="marketing-primary-nav" title {...props} />
  );
}

// id: "10caabd7-4a35-43fa-a8a0-3cc87e25f717"
// title: "Levels 1-4 Explained"
// type: :html
// key: "about-leveling-page"
// parent_id: nil
export function AboutLevelingPage10caabd74a3543faA8a03cc87e25f717(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutLevelingPage10caabd74a3543faA8a03cc87e25f717`}>
      {props["header"] || <SecondaryMarketingHeader8aca20333265438fAc457e9bd43ceea1 parentTag="HeaderC26b5246F9a04a5bA321Eb275fcdd63f" title="Leveling" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter9326855fD3ca4792B28c5065a9d16982 parentTag="Footer4f01a46358a1400885bd18a1e1002168" {...props} />}
    </div>
  );
}

// id: "565dfaa0-31ea-4277-87c4-9d6c83a5380a"
// title: ""
// type: :reference
// key: "header"
// parent_id: "296811eb-88ab-4b58-91b5-0fe7d26b7ec7"
export function Header565dfaa031ea427787c49d6c83a5380a(props: any) {
  return (
    <HomeHeader72b710e6Acf64d1d8a2394268d09b1b3 parentTag="Header565dfaa031ea427787c49d6c83a5380a" {...props} />
  );
}

// id: "ae4ebc2a-d870-46f0-b24a-6e9294f8a38b"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "4f9e97bd-f7ba-4870-a66b-fb3d80b38096"
export function NavigationAe4ebc2aD87046f0B24a6e9294f8a38b(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="NavigationAe4ebc2aD87046f0B24a6e9294f8a38b" parentTag={buildClassName("NavigationAe4ebc2aD87046f0B24a6e9294f8a38b", parentTag)} navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "da1fae35-4743-40a5-9b34-87e6c0afdd7e"
// title: ""
// type: :text
// key: "title"
// parent_id: "aea49ec2-6e96-4bdf-b267-cad9c6ec51ce"
export const TitleDa1fae35474340a59b3487e6c0afdd7e = "Public Events";

// id: "70c25caf-152e-48ea-bbf7-52f033c4779a"
// title: "omen-image-gallery"
// type: :html
// key: "omen-image-gallery"
// parent_id: "0082cffe-f5be-4f23-b1b1-679f420360e8"
export function OmenImageGallery70c25caf152e48eaBbf752f033c4779a(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} OmenImageGallery70c25caf152e48eaBbf752f033c4779a omen-image-main-container`}>
      <div className="omen-image-inner-container">
        <div>
          <h1>
            Images From Past Events
          </h1>
        </div>
        <div className="omen-gallery">
          <div className="omen-gallery-fw-img">
            <img src="https://mp1md-pub.s3-us-west-2.amazonaws.com/content/m3EBzoFl-lnsTJiv_regular.jpeg" alt="Image 1" />
          </div>
          <div className="inner-gallery-container">
            <div className="inner-gallery-left-container">
              <img src="https://mp1md-pub.s3-us-west-2.amazonaws.com/content/QY4rSV-Bl1yr9eWn_regular.jpeg" alt="Image 2" />
              <img src="https://mp1md-pub.s3-us-west-2.amazonaws.com/content/V6el6MEvsG8P210p_regular.jpeg" alt="Image 3" />
              <img src="https://mp1md-pub.s3-us-west-2.amazonaws.com/content/t648HTYQLalFs0uA_regular.jpeg" alt="Image 4" />
            </div>
            <div className="inner-gallery-right-container">
              <img src="https://mp1md-pub.s3-us-west-2.amazonaws.com/content/FiJKcorx594UcY9j_regular.jpeg" alt="Image 5" />
              <img src="https://mp1md-pub.s3-us-west-2.amazonaws.com/content/ipHpKSVapJPjM3fV_regular.jpeg" alt="Image 6" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// id: "1efd66b3-f63b-40cc-aaa9-27bd085fb360"
// title: "Label"
// type: :reference
// key: "label"
// parent_id: nil
export function Label1efd66b3F63b40ccAaa927bd085fb360(props: any) {
  return (
    <DefaultLogoEe238e6dD8044e669ed21f096bcbcd71 parentTag="Label1efd66b3F63b40ccAaa927bd085fb360" {...props} />
  );
}

// id: "a39ef99c-3198-4256-9fd8-bb1e1500cfb1"
// title: "Marketing Cards Body"
// type: :html
// key: "marketing-body"
// parent_id: nil
export function MarketingBodyA39ef99c319842569fd8Bb1e1500cfb1(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MarketingBodyA39ef99c319842569fd8Bb1e1500cfb1 page-body`} />
  );
}

// id: "a76cb767-72a9-43ac-bf0d-f174671cee77"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "27f579b5-d629-46a5-839a-850b9f70f2bd"
export function FooterA76cb76772a943acBf0dF174671cee77(props: any) {
  return (
    <DefaultFooter9326855fD3ca4792B28c5065a9d16982 parentTag="FooterA76cb76772a943acBf0dF174671cee77" {...props} />
  );
}

// id: "162de8ad-4625-4aee-bf6b-8abb57709019"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "b4c1c06f-744d-426f-809c-dafa48a3bf1d"
export const ContentSlug162de8ad46254aeeBf6b8abb57709019 = "about-us";

// id: "ea06bfc1-c12b-41f5-9560-c587c0f175a0"
// title: "our-story"
// type: :html
// key: "our-story"
// parent_id: "0082cffe-f5be-4f23-b1b1-679f420360e8"
export function OurStoryEa06bfc1C12b41f59560C587c0f175a0(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <section className={`${parentTag || ""} OurStoryEa06bfc1C12b41f59560C587c0f175a0`}>
      <div className="our-story-main-container">
        <div className="background-container">
          <div className="content-container">
            <div className="text">
              <h1>
                Our Story
              </h1>
              <p>
                The idea for a men’s naturist group in Portland, Oregon was born in the mind of Jim F. Jim,
                having
                been an avid naturist for many years and a member of GNI (Gay Naturists International).
              </p>
              <a href="/about">
                Learn More &gt;
              </a>
            </div>
            <div className="image">
              <img src="https://mp1md-pub.s3-us-west-2.amazonaws.com/content/VsecOwm1SXEF1_1B_regular.jpeg" alt="Group Photo" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// id: "31897716-13df-4b0c-9967-862e1d5855ad"
// title: "Members Header"
// type: :reference
// key: "header"
// parent_id: nil
export function Header3189771613df4b0c9967862e1d5855ad(props: any) {
  return (
    <MembersAreaHeader972591a7Ba0146708e4fC1b376bff0d2 parentTag="Header3189771613df4b0c9967862e1d5855ad" {...props} />
  );
}

// id: "4f9e97bd-f7ba-4870-a66b-fb3d80b38096"
// title: "Short Header"
// type: :html
// key: "short-header"
// parent_id: nil
export function ShortHeader4f9e97bdF7ba4870A66bFb3d80b38096(props: any) {
  const Link = AppStore.presets["Link"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} ShortHeader4f9e97bdF7ba4870A66bFb3d80b38096 site-header`}>
      <div className="background-image" />
      <div className="header-top">
        {props["linked-logo"] || <Link className="LinkedLogo2c859f3576db48dbBc8eBbb2f01da881" parentTag={buildClassName("LinkedLogo2c859f3576db48dbBc8eBbb2f01da881", parentTag)} label={<DefaultLogoEe238e6dD8044e669ed21f096bcbcd71 parentTag="Label5c135844153f4ff9A3a13f6576fad55d" alt="logo" />} {...props} />}
        {props["navigation"] || <PrimaryNavigation className="NavigationAe4ebc2aD87046f0B24a6e9294f8a38b" parentTag={buildClassName("NavigationAe4ebc2aD87046f0B24a6e9294f8a38b", parentTag)} navMenuSlug="members-primary-nav" {...props} />}
      </div>
    </div>
  );
}

// id: "0c5a788d-b105-4d62-b626-7d86f83f2715"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "296811eb-88ab-4b58-91b5-0fe7d26b7ec7"
export function Quote0c5a788dB1054d62B6267d86f83f2715(props: any) {
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="Quote0c5a788dB1054d62B6267d86f83f2715" parentTag={buildClassName("Quote0c5a788dB1054d62B6267d86f83f2715", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "35cb4e2e-79fb-4d38-a3bd-54283e086169"
// title: ""
// type: :reference
// key: "label"
// parent_id: "bfa4bb1c-af41-4971-98ca-5d272fa5622f"
export function Label35cb4e2e79fb4d38A3bd54283e086169(props: any) {
  return (
    <DefaultLogoEe238e6dD8044e669ed21f096bcbcd71 parentTag="Label35cb4e2e79fb4d38A3bd54283e086169" {...props} />
  );
}

// id: "dbd7cab6-2911-46fb-aa61-766d45ee432d"
// title: ""
// type: :gf_preset
// key: "events-button"
// parent_id: "418f4997-10dc-40c9-9ca8-9a38fb06a750"
export function EventsButtonDbd7cab6291146fbAa61766d45ee432d(props: any) {
  const Button = AppStore.presets["Button"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Button className="EventsButtonDbd7cab6291146fbAa61766d45ee432d" parentTag={buildClassName("EventsButtonDbd7cab6291146fbAa61766d45ee432d", parentTag)} href="/events/public" className="events-btn secondary transition" label="View Upcoming Events" {...props} />
  );
}

// id: "cdf4ed73-9239-48e8-b26d-665c00d51da6"
// title: "Resources Page"
// type: :reference
// key: "resources-page"
// parent_id: nil
export function ResourcesPageCdf4ed73923948e8B26d665c00d51da6(props: any) {
  return (
    <SecondaryPage27f579b5D62946a5839a850b9f70f2bd parentTag="ResourcesPageCdf4ed73923948e8B26d665c00d51da6" header={<SecondaryMarketingHeader8aca20333265438fAc457e9bd43ceea1 parentTag="Header8655273e2de44f44Aaf407a8d3e2cd28" title="Resources" />} {...props} />
  );
}

// id: "72b710e6-acf6-4d1d-8a23-94268d09b1b3"
// title: "Home Header"
// type: :html
// key: "home-header"
// parent_id: nil
export function HomeHeader72b710e6Acf64d1d8a2394268d09b1b3(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomeHeader72b710e6Acf64d1d8a2394268d09b1b3 site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopE752d40187ea4ded95fb0e765a721acd parentTag="HeaderTop924d698456c748d0894bEe39094f1af9" {...props} />}
      </div>
      <div className="hero-banner-container">
        {props["hero"] || <Hero className="Hero434c22a857f74c7a8aeb539fc915a2e1" parentTag={buildClassName("Hero434c22a857f74c7a8aeb539fc915a2e1", parentTag)} postSlug="home-hero" {...props} />}
      </div>
    </div>
  );
}

// id: "98ed25f0-0397-488d-af56-12797606326f"
// title: "Marketing Primary Navigation"
// type: :text
// key: "navMenuSlug"
// parent_id: "31faccfd-bcef-4475-b2c1-d641bdc1b0f8"
export const NavMenuSlug98ed25f00397488dAf5612797606326f = "marketing-primary-nav";

// id: "bdd3e1dc-6b18-4afd-8972-fe8bc1107de7"
// title: ""
// type: :reference
// key: "why-omen"
// parent_id: "a39ef99c-3198-4256-9fd8-bb1e1500cfb1"
export function WhyOmenBdd3e1dc6b184afd8972Fe8bc1107de7(props: any) {
  return (
    <WhyOmenBdd3e1dc6b184afd8972Fe8bc1107de7 parentTag="WhyOmenBdd3e1dc6b184afd8972Fe8bc1107de7" {...props} />
  );
}

// id: "26d00224-2cdb-421d-ac72-a028a22073b4"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "5931d815-5c75-41c5-88ee-aa1b29427ede"
export const NavMenuSlug26d002242cdb421dAc72A028a22073b4 = "marketing-primary-nav";

// id: "8a7436d2-5757-4a1b-8a72-dec2de484fc3"
// title: ""
// type: :gf_preset
// key: "join-button"
// parent_id: "418f4997-10dc-40c9-9ca8-9a38fb06a750"
export function JoinButton8a7436d257574a1b8a72Dec2de484fc3(props: any) {
  const Link = AppStore.presets["Link"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="JoinButton8a7436d257574a1b8a72Dec2de484fc3" parentTag={buildClassName("JoinButton8a7436d257574a1b8a72Dec2de484fc3", parentTag)} href="/join" label="Become A Member" className="member-btn transition" {...props} />
  );
}

// id: "d162191f-8aee-46d8-b4e8-a81e9a91bbf4"
// title: "About Us"
// type: :html
// key: "about-us-page"
// parent_id: nil
export function AboutUsPageD162191f8aee46d8B4e8A81e9a91bbf4(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutUsPageD162191f8aee46d8B4e8A81e9a91bbf4 page`}>
      {props["header"] || <SecondaryMarketingHeader8aca20333265438fAc457e9bd43ceea1 parentTag="Header36f7660bF44843388744151e508a8211" title="About Us" {...props} />}
      <main>
        <div className="main-inner">
          {props["content"] || <ContentItem className="ContentB4c1c06f744d426f809cDafa48a3bf1d" parentTag={buildClassName("ContentB4c1c06f744d426f809cDafa48a3bf1d", parentTag)} subType="page" contentSlug="about-us" as="div" className="about-us" {...props} />}
        </div>
      </main>
      {props["footer"] || <DefaultFooter9326855fD3ca4792B28c5065a9d16982 parentTag="Footer14db60111c744f24A50933b179cd3f0b" {...props} />}
    </div>
  );
}

// id: "3c24d4b7-30c9-4e44-b307-0b28451ef3b7"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "6d644d16-a544-45e2-9aa2-7225b2564b14"
export function Footer3c24d4b730c94e44B3070b28451ef3b7(props: any) {
  return (
    <DefaultFooter9326855fD3ca4792B28c5065a9d16982 parentTag="Footer3c24d4b730c94e44B3070b28451ef3b7" {...props} />
  );
}

// id: "c26b5246-f9a0-4a5b-a321-eb275fcdd63f"
// title: ""
// type: :reference
// key: "header"
// parent_id: "10caabd7-4a35-43fa-a8a0-3cc87e25f717"
export function HeaderC26b5246F9a04a5bA321Eb275fcdd63f(props: any) {
  return (
    <SecondaryMarketingHeader8aca20333265438fAc457e9bd43ceea1 parentTag="HeaderC26b5246F9a04a5bA321Eb275fcdd63f" title="Leveling" {...props} />
  );
}

// id: "45f9f8c9-c4b4-4888-aeac-ec5d17dd33a1"
// title: ""
// type: :reference
// key: "header"
// parent_id: "cec4bc13-e390-4eb5-ae0c-2027c80ad748"
export function Header45f9f8c9C4b44888AeacEc5d17dd33a1(props: any) {
  return (
    <MembersAreaHeader972591a7Ba0146708e4fC1b376bff0d2 parentTag="Header45f9f8c9C4b44888AeacEc5d17dd33a1" {...props} />
  );
}

// id: "1e102fd4-8258-45ab-948c-0c0fe6b4534d"
// title: ""
// type: :text
// key: "as"
// parent_id: "b4c1c06f-744d-426f-809c-dafa48a3bf1d"
export const As1e102fd4825845ab948c0c0fe6b4534d = "div";

// id: "3d932f85-2cde-44c1-9735-c4dc6e8908c7"
// title: ""
// type: :text
// key: "href"
// parent_id: "8a7436d2-5757-4a1b-8a72-dec2de484fc3"
export const Href3d932f852cde44c19735C4dc6e8908c7 = "/join";

// id: "cec4bc13-e390-4eb5-ae0c-2027c80ad748"
// title: "Member Pages"
// type: :html
// key: "member-pages"
// parent_id: nil
export function MemberPagesCec4bc13E3904eb5Ae0c2027c80ad748(props: any) {
  const SecondaryNavigation = AppStore.presets["SecondaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MemberPagesCec4bc13E3904eb5Ae0c2027c80ad748`}>
      {props["header"] || <MembersAreaHeader972591a7Ba0146708e4fC1b376bff0d2 parentTag="Header45f9f8c9C4b44888AeacEc5d17dd33a1" {...props} />}
      {props["secondary-nav"] || <SecondaryNavigation className="SecondaryNav678ea6e8Bfb54fcaB23a4e97f71b84d1" parentTag={buildClassName("SecondaryNav678ea6e8Bfb54fcaB23a4e97f71b84d1", parentTag)} {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter9326855fD3ca4792B28c5065a9d16982 parentTag="FooterD27d1416F0864ed4Bea9D985b869dedc" {...props} />}
    </div>
  );
}

// id: "8acea695-41a0-41cc-8366-f2c7f577444a"
// title: ""
// type: :gf_preset
// key: "welcome-back"
// parent_id: "296811eb-88ab-4b58-91b5-0fe7d26b7ec7"
export function WelcomeBack8acea69541a041cc8366F2c7f577444a(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <WelcomeBackPopUp className="WelcomeBack8acea69541a041cc8366F2c7f577444a" parentTag={buildClassName("WelcomeBack8acea69541a041cc8366F2c7f577444a", parentTag)} {...props} />
  );
}

// id: "8655273e-2de4-4f44-aaf4-07a8d3e2cd28"
// title: ""
// type: :reference
// key: "header"
// parent_id: "cdf4ed73-9239-48e8-b26d-665c00d51da6"
export function Header8655273e2de44f44Aaf407a8d3e2cd28(props: any) {
  return (
    <SecondaryMarketingHeader8aca20333265438fAc457e9bd43ceea1 parentTag="Header8655273e2de44f44Aaf407a8d3e2cd28" title="Resources" {...props} />
  );
}

// id: "36f7660b-f448-4338-8744-151e508a8211"
// title: ""
// type: :reference
// key: "header"
// parent_id: "d162191f-8aee-46d8-b4e8-a81e9a91bbf4"
export function Header36f7660bF44843388744151e508a8211(props: any) {
  return (
    <SecondaryMarketingHeader8aca20333265438fAc457e9bd43ceea1 parentTag="Header36f7660bF44843388744151e508a8211" title="About Us" {...props} />
  );
}

// id: "f62fcbe2-5033-4c4d-a85e-a4ac87f1cd49"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "ea6fb991-d544-464b-b8da-147317734448"
export const NavMenuSlugF62fcbe250334c4dA85eA4ac87f1cd49 = "members-primary-nav";

// id: "b4df585b-a1c8-4f52-8f34-a57e772a63c4"
// title: ""
// type: :text
// key: "label"
// parent_id: "8a7436d2-5757-4a1b-8a72-dec2de484fc3"
export const LabelB4df585bA1c84f528f34A57e772a63c4 = "Become A Member";

// id: "8aca2033-3265-438f-ac45-7e9bd43ceea1"
// title: "Secondary Marketing Header"
// type: :html
// key: "secondary-marketing-header"
// parent_id: nil
export function SecondaryMarketingHeader8aca20333265438fAc457e9bd43ceea1(props: any) {
  const { parentTag, ...rest } = props;
  props = { title: "Secondary Marketing Title 1", ...rest };
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeader8aca20333265438fAc457e9bd43ceea1 site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopE752d40187ea4ded95fb0e765a721acd parentTag="HeaderTopC18bb6f392d14ba2Afe43b09483ed555" {...props} />}
      </div>
      {props["hero"] || <SecondaryMarketingHero0b4bf3ff55b6475aA1025ac8cdfb8f84 parentTag="HeroF4ff8cd094594d85A721D73c53c8cf40" title="Secondary Marketing Title 2" {...props} />}
    </div>
  );
}

// id: "bd083fb5-2f88-4cff-869d-f10b9892b8a7"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "c2b9633b-d80c-49f6-af8f-b3970bdb7529"
export const PostSlugBd083fb52f884cff869dF10b9892b8a7 = "home-page-posts2";

// id: "5931d815-5c75-41c5-88ee-aa1b29427ede"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "e752d401-87ea-4ded-95fb-0e765a721acd"
export function Navigation5931d8155c7541c588eeAa1b29427ede(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="Navigation5931d8155c7541c588eeAa1b29427ede" parentTag={buildClassName("Navigation5931d8155c7541c588eeAa1b29427ede", parentTag)} navMenuSlug="marketing-primary-nav" className="navigation" {...props} />
  );
}

// id: "ea6fb991-d544-464b-b8da-147317734448"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "972591a7-ba01-4670-8e4f-c1b376bff0d2"
export function HeaderTopEa6fb991D544464bB8da147317734448(props: any) {
  return (
    <DefaultHeaderTopE752d40187ea4ded95fb0e765a721acd parentTag="HeaderTopEa6fb991D544464bB8da147317734448" navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "bbbacd7a-1d72-4c05-a048-16fe840b5636"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "ae4ebc2a-d870-46f0-b24a-6e9294f8a38b"
export const NavMenuSlugBbbacd7a1d724c05A04816fe840b5636 = "members-primary-nav";

// id: "04d2a5d3-4fe5-4369-a34e-3f99d883f31e"
// title: ""
// type: :text
// key: "class"
// parent_id: "8a7436d2-5757-4a1b-8a72-dec2de484fc3"
export const Class04d2a5d34fe54369A34e3f99d883f31e = "member-btn transition";

// id: "e752d401-87ea-4ded-95fb-0e765a721acd"
// title: "Header Area Top"
// type: :html
// key: "default-header-top"
// parent_id: nil
export function DefaultHeaderTopE752d40187ea4ded95fb0e765a721acd(props: any) {
  const Link = AppStore.presets["Link"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultHeaderTopE752d40187ea4ded95fb0e765a721acd header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogoBfa4bb1cAf41497198ca5d272fa5622f" parentTag={buildClassName("LinkedLogoBfa4bb1cAf41497198ca5d272fa5622f", parentTag)} url="/" label={<DefaultLogoEe238e6dD8044e669ed21f096bcbcd71 parentTag="Label35cb4e2e79fb4d38A3bd54283e086169" alt="logo" />} className="linked-logo" {...props} />}
      {props["navigation"] || <PrimaryNavigation className="Navigation5931d8155c7541c588eeAa1b29427ede" parentTag={buildClassName("Navigation5931d8155c7541c588eeAa1b29427ede", parentTag)} navMenuSlug="marketing-primary-nav" className="navigation" {...props} />}
    </div>
  );
}

// id: "1b4f57e2-4d27-4255-b6e7-2c2e51c43706"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "296811eb-88ab-4b58-91b5-0fe7d26b7ec7"
export function Footer1b4f57e24d274255B6e72c2e51c43706(props: any) {
  return (
    <DefaultFooter9326855fD3ca4792B28c5065a9d16982 parentTag="Footer1b4f57e24d274255B6e72c2e51c43706" {...props} />
  );
}

// id: "bfa4bb1c-af41-4971-98ca-5d272fa5622f"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "e752d401-87ea-4ded-95fb-0e765a721acd"
export function LinkedLogoBfa4bb1cAf41497198ca5d272fa5622f(props: any) {
  const Link = AppStore.presets["Link"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogoBfa4bb1cAf41497198ca5d272fa5622f" parentTag={buildClassName("LinkedLogoBfa4bb1cAf41497198ca5d272fa5622f", parentTag)} url="/" label={<DefaultLogoEe238e6dD8044e669ed21f096bcbcd71 parentTag="Label35cb4e2e79fb4d38A3bd54283e086169" alt="logo" />} className="linked-logo" {...props} />
  );
}

// id: "f21180e8-8954-4ca0-ac7e-ed2b6ffe568f"
// title: ""
// type: :text
// key: "backgroundImage"
// parent_id: "72b710e6-acf6-4d1d-8a23-94268d09b1b3"
export const BackgroundImageF21180e889544ca0Ac7eEd2b6ffe568f = "https://mp1md-pub.s3.amazonaws.com/orgs/demo-1/Moving_Forest_1050_700.webp";

// id: "a8883b74-d1ad-48f7-8d3b-6c2510b0cd61"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "eeaa9ec4-3b54-4f79-973c-aad84414d487"
export const NavMenuSlugA8883b74D1ad48f78d3b6c2510b0cd61 = "footer-nav";

// id: "c8ea2f25-0c76-4591-8260-e7624555e3d9"
// title: ""
// type: :text
// key: "href"
// parent_id: "dbd7cab6-2911-46fb-aa61-766d45ee432d"
export const HrefC8ea2f250c7645918260E7624555e3d9 = "/events/public";

// id: "0b4bf3ff-55b6-475a-a102-5ac8cdfb8f84"
// title: "Secondary Marketing Hero"
// type: :html
// key: "secondary-marketing-hero"
// parent_id: nil
export function SecondaryMarketingHero0b4bf3ff55b6475aA1025ac8cdfb8f84(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHero0b4bf3ff55b6475aA1025ac8cdfb8f84 hero`}>
      <div className="title">
        {props["title"] || TitleBe8b81233d17455290cbCe46f853f719}
      </div>
    </div>
  );
}

// id: "140b05e5-c27d-4821-a1f9-bcef44a3fb98"
// title: ""
// type: :text
// key: "buttonClass"
// parent_id: "c2b9633b-d80c-49f6-af8f-b3970bdb7529"
export const ButtonClass140b05e5C27d4821A1f9Bcef44a3fb98 = "inline-block px-12 py-3 hover:brightness-110 transition duration";

// id: "eeaa9ec4-3b54-4f79-973c-aad84414d487"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "9326855f-d3ca-4792-b28c-5065a9d16982"
export function LinksEeaa9ec43b544f79973cAad84414d487(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="LinksEeaa9ec43b544f79973cAad84414d487" parentTag={buildClassName("LinksEeaa9ec43b544f79973cAad84414d487", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "b068410b-b6c5-4631-953b-0ab88ec3623c"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "9326855f-d3ca-4792-b28c-5065a9d16982"
export function GroupflowB068410bB6c54631953b0ab88ec3623c(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="GroupflowB068410bB6c54631953b0ab88ec3623c" parentTag={buildClassName("GroupflowB068410bB6c54631953b0ab88ec3623c", parentTag)} {...props} />
  );
}

// id: "d8a337da-21d4-435e-aa81-30637bb192ae"
// title: ""
// type: :text
// key: "title"
// parent_id: "25450764-fa7b-4f47-a31b-94bff0c310c8"
export const TitleD8a337da21d4435eAa8130637bb192ae = "Secondary Page";

// id: "3bd60259-2454-4589-bae5-45f28a1b9b82"
// title: ""
// type: :text
// key: "class"
// parent_id: "dbd7cab6-2911-46fb-aa61-766d45ee432d"
export const Class3bd6025924544589Bae545f28a1b9b82 = "events-btn secondary transition";

// id: "b96404ad-685a-4554-aaff-0f6e5da638ed"
// title: "Page Quote"
// type: :html
// key: "page-quote"
// parent_id: nil
export function PageQuoteB96404ad685a4554Aaff0f6e5da638ed(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PageQuoteB96404ad685a4554Aaff0f6e5da638ed`}>
      <div>
      </div>
      <div>
      </div>
    </div>
  );
}

// id: "2158ad41-6a64-442b-bc6e-4342bc1dd973"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "0eb0fc95-12ed-4240-86fe-8bae2600e8fc"
export function Footer2158ad416a64442bBc6e4342bc1dd973(props: any) {
  return (
    <DefaultFooter9326855fD3ca4792B28c5065a9d16982 parentTag="Footer2158ad416a64442bBc6e4342bc1dd973" {...props} />
  );
}

// id: "14db6011-1c74-4f24-a509-33b179cd3f0b"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "d162191f-8aee-46d8-b4e8-a81e9a91bbf4"
export function Footer14db60111c744f24A50933b179cd3f0b(props: any) {
  return (
    <DefaultFooter9326855fD3ca4792B28c5065a9d16982 parentTag="Footer14db60111c744f24A50933b179cd3f0b" {...props} />
  );
}

// id: "669c6d63-9d2f-4fd9-b0b9-a5dd2189f6cd"
// title: ""
// type: :reference
// key: "header"
// parent_id: "9f16e4e1-5e9f-4ff5-9b2e-dfa081e46914"
export function Header669c6d639d2f4fd9B0b9A5dd2189f6cd(props: any) {
  return (
    <SecondaryMarketingHeader8aca20333265438fAc457e9bd43ceea1 parentTag="Header669c6d639d2f4fd9B0b9A5dd2189f6cd" title="Join Us" {...props} />
  );
}

// id: "a519ee7d-1467-40d8-8ab0-dfe61569450e"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "ef184ce6-1147-4632-9c16-8f0ce645e8da"
export const PostSlugA519ee7d146740d88ab0Dfe61569450e = "about-us-posts";

// id: "8f507075-4741-443b-a5c0-dfb118f3ab07"
// title: ""
// type: :text
// key: "label"
// parent_id: "dbd7cab6-2911-46fb-aa61-766d45ee432d"
export const Label8f5070754741443bA5c0Dfb118f3ab07 = "View Upcoming Events";

// id: "609d72a2-2b0b-4ad7-b8c6-390e7ed690e2"
// title: "Message Pages"
// type: :html
// key: "message-pages"
// parent_id: nil
export function MessagePages609d72a22b0b4ad7B8c6390e7ed690e2(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MessagePages609d72a22b0b4ad7B8c6390e7ed690e2`}>
      {props["header"] || <MembersAreaHeader972591a7Ba0146708e4fC1b376bff0d2 parentTag="Header3ff6660f9f6149eaBbf6F840e9f3e4a1" {...props} />}
      {props.children}
    </div>
  );
}

// id: "3ff6660f-9f61-49ea-bbf6-f840e9f3e4a1"
// title: ""
// type: :reference
// key: "header"
// parent_id: "609d72a2-2b0b-4ad7-b8c6-390e7ed690e2"
export function Header3ff6660f9f6149eaBbf6F840e9f3e4a1(props: any) {
  return (
    <MembersAreaHeader972591a7Ba0146708e4fC1b376bff0d2 parentTag="Header3ff6660f9f6149eaBbf6F840e9f3e4a1" {...props} />
  );
}

// id: "df977f0d-c0a1-45c0-8d69-a193005d293b"
// title: ""
// type: :html
// key: "logo"
// parent_id: "9326855f-d3ca-4792-b28c-5065a9d16982"
export function LogoDf977f0dC0a145c08d69A193005d293b(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3-us-west-2.amazonaws.com/content/qD9ySvYVxmpqtVP1_regular.png" alt="Demo 1 logo" className={`${parentTag || ""} LogoDf977f0dC0a145c08d69A193005d293b logo`} />
  );
}

// id: "b4c1c06f-744d-426f-809c-dafa48a3bf1d"
// title: ""
// type: :gf_preset
// key: "content"
// parent_id: "d162191f-8aee-46d8-b4e8-a81e9a91bbf4"
export function ContentB4c1c06f744d426f809cDafa48a3bf1d(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="ContentB4c1c06f744d426f809cDafa48a3bf1d" parentTag={buildClassName("ContentB4c1c06f744d426f809cDafa48a3bf1d", parentTag)} subType="page" contentSlug="about-us" as="div" className="about-us" {...props} />
  );
}

// id: "cf66dc86-3cbe-4ec8-a538-96c83b39de93"
// title: ""
// type: :text
// key: "title"
// parent_id: "36f7660b-f448-4338-8744-151e508a8211"
export const TitleCf66dc863cbe4ec8A53896c83b39de93 = "About Us";

// id: "77685f98-3e32-4c03-bde0-f8e2a132ef2e"
// title: "Admin Pages"
// type: :html
// key: "admin-pages"
// parent_id: nil
export function AdminPages77685f983e324c03Bde0F8e2a132ef2e(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AdminPages77685f983e324c03Bde0F8e2a132ef2e`}>
      {props.children}
    </div>
  );
}

// id: "8f5c0942-d56e-4e4a-a558-9ec82b3931b5"
// title: ""
// type: :text
// key: "alt"
// parent_id: "ee238e6d-d804-4e66-9ed2-1f096bcbcd71"
export const Alt8f5c0942D56e4e4aA5589ec82b3931b5 = "logo";

// id: "6c9c28bf-c476-44e9-9dc8-0f0c37586926"
// title: ""
// type: :text
// key: "title"
// parent_id: "31faccfd-bcef-4475-b2c1-d641bdc1b0f8"
export const Title6c9c28bfC47644e99dc80f0c37586926 = null;

// id: "1f2eb380-4ce3-4b0e-a306-a5bf765f71a9"
// title: ""
// type: :reference
// key: "header"
// parent_id: "5411187e-679e-4dfa-a140-e28ccc220f93"
export function Header1f2eb3804ce34b0eA306A5bf765f71a9(props: any) {
  return (
    <SecondaryMarketingHeader8aca20333265438fAc457e9bd43ceea1 parentTag="Header1f2eb3804ce34b0eA306A5bf765f71a9" title="Join Us" {...props} />
  );
}

// id: "ca5b56b1-b4a4-478f-8db3-be53e194ea9c"
// title: ""
// type: :text
// key: "class"
// parent_id: "5931d815-5c75-41c5-88ee-aa1b29427ede"
export const ClassCa5b56b1B4a4478f8db3Be53e194ea9c = "navigation";

// id: "86942ecb-d85f-4cad-8037-91ab055e6f02"
// title: "HREF"
// type: :text
// key: "href"
// parent_id: nil
export const Href86942ecbD85f4cad803791ab055e6f02 = "/";

// id: "25450764-fa7b-4f47-a31b-94bff0c310c8"
// title: ""
// type: :reference
// key: "header"
// parent_id: "27f579b5-d629-46a5-839a-850b9f70f2bd"
export function Header25450764Fa7b4f47A31b94bff0c310c8(props: any) {
  return (
    <SecondaryMarketingHeader8aca20333265438fAc457e9bd43ceea1 parentTag="Header25450764Fa7b4f47A31b94bff0c310c8" title="Secondary Page" {...props} />
  );
}

// id: "bf1842c7-adf3-4abd-a606-d0941aaa48d1"
// title: ""
// type: :text
// key: "imageUrl"
// parent_id: "ee238e6d-d804-4e66-9ed2-1f096bcbcd71"
export const ImageUrlBf1842c7Adf34abdA606D0941aaa48d1 = "https://mp1md-pub.s3-us-west-2.amazonaws.com/content/qD9ySvYVxmpqtVP1_regular.png";

// id: "d27d1416-f086-4ed4-bea9-d985b869dedc"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "cec4bc13-e390-4eb5-ae0c-2027c80ad748"
export function FooterD27d1416F0864ed4Bea9D985b869dedc(props: any) {
  return (
    <DefaultFooter9326855fD3ca4792B28c5065a9d16982 parentTag="FooterD27d1416F0864ed4Bea9D985b869dedc" {...props} />
  );
}

// id: "781b995b-46f4-4e60-b27b-98db192db166"
// title: ""
// type: :text
// key: "title"
// parent_id: "c26b5246-f9a0-4a5b-a321-eb275fcdd63f"
export const Title781b995b46f44e60B27b98db192db166 = "Leveling";

// id: "5411187e-679e-4dfa-a140-e28ccc220f93"
// title: "Signup Pages"
// type: :reference
// key: "signup-pages"
// parent_id: nil
export function SignupPages5411187e679e4dfaA140E28ccc220f93(props: any) {
  return (
    <SecondaryPage27f579b5D62946a5839a850b9f70f2bd parentTag="SignupPages5411187e679e4dfaA140E28ccc220f93" header={<SecondaryMarketingHeader8aca20333265438fAc457e9bd43ceea1 parentTag="Header1f2eb3804ce34b0eA306A5bf765f71a9" title="Join Us" />} {...props} />
  );
}

// id: "434c22a8-57f7-4c7a-8aeb-539fc915a2e1"
// title: ""
// type: :gf_preset
// key: "hero"
// parent_id: "72b710e6-acf6-4d1d-8a23-94268d09b1b3"
export function Hero434c22a857f74c7a8aeb539fc915a2e1(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Hero className="Hero434c22a857f74c7a8aeb539fc915a2e1" parentTag={buildClassName("Hero434c22a857f74c7a8aeb539fc915a2e1", parentTag)} postSlug="home-hero" {...props} />
  );
}

// id: "c18bb6f3-92d1-4ba2-afe4-3b09483ed555"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "8aca2033-3265-438f-ac45-7e9bd43ceea1"
export function HeaderTopC18bb6f392d14ba2Afe43b09483ed555(props: any) {
  return (
    <DefaultHeaderTopE752d40187ea4ded95fb0e765a721acd parentTag="HeaderTopC18bb6f392d14ba2Afe43b09483ed555" {...props} />
  );
}

// id: "f7cbb265-2f26-4c2f-8651-983df015323f"
// title: ""
// type: :text
// key: "title"
// parent_id: "1f2eb380-4ce3-4b0e-a306-a5bf765f71a9"
export const TitleF7cbb2652f264c2f8651983df015323f = "Join Us";

// id: "ebd239dd-825d-4afd-a0c3-2e77c7dfd164"
// title: ""
// type: :text
// key: "class"
// parent_id: "bfa4bb1c-af41-4971-98ca-5d272fa5622f"
export const ClassEbd239dd825d4afdA0c32e77c7dfd164 = "linked-logo";

// id: "bcdaceea-5359-41af-8fdb-99937eca0803"
// title: ""
// type: :text
// key: "className"
// parent_id: "b4c1c06f-744d-426f-809c-dafa48a3bf1d"
export const ClassNameBcdaceea535941af8fdb99937eca0803 = "about-us";

// id: "ada3f963-3036-44c9-9081-c5b8b966b905"
// title: ""
// type: :text
// key: "title"
// parent_id: "669c6d63-9d2f-4fd9-b0b9-a5dd2189f6cd"
export const TitleAda3f963303644c99081C5b8b966b905 = "Join Us";

const Components = {
  JoinUsPage9f16e4e15e9f4ff59b2eDfa081e46914,
  DefaultFooter9326855fD3ca4792B28c5065a9d16982,
  Footer4f01a46358a1400885bd18a1e1002168,
  HeroF4ff8cd094594d85A721D73c53c8cf40,
  JoinOmen6a1db0e569ca4821B004A6ef5a1d65f7,
  MoreQuestions418f499710dc40c99ca89a38fb06a750,
  PublicEventsPage6d644d16A54445e29aa27225b2564b14,
  MembersAreaDefault0eb0fc9512ed424086fe8bae2600e8fc,
  BodyEf184ce6114746329c168f0ce645e8da,
  Body0082cffeF5be4f23B1b1679f420360e8,
  DefaultLogoEe238e6dD8044e669ed21f096bcbcd71,
  MarketingCardsC2b9633bD80c49f6Af8fB3970bdb7529,
  Copyright15533833F338497fBe7a74e9aaa1e22b,
  Header28c59e43D7f0406e8acf07f97526a936,
  UrlBee4ad69993542719731B5bcda270557,
  Title1d596b751d3041289166792793475e8d,
  Title69e2f3d52d6e4223833d033d72afd40e,
  MembersAreaHeader972591a7Ba0146708e4fC1b376bff0d2,
  TitleDcdb56ad5f6641b7999f474c9cbf04c6,
  TitleBe8b81233d17455290cbCe46f853f719,
  Title4164aaa762d542a9A511Ed995d2beeac,
  PostSlugCaa59f3779034987B314Cc0e7cfa1d1f,
  HomePage296811eb88ab4b5891b50fe7d26b7ec7,
  WhyOmenD2e433f995ec4f2d9606B016934ee952,
  LinkedLogo2c859f3576db48dbBc8eBbb2f01da881,
  HeaderAea49ec26e964bdfB267Cad9c6ec51ce,
  SubType6ef79ca808de4e78Bf5628d00eb00618,
  Label5c135844153f4ff9A3a13f6576fad55d,
  Footer94eed9ff828d4e6dB08cBbaa13d13a01,
  SecondaryPage27f579b5D62946a5839a850b9f70f2bd,
  HeaderTop924d698456c748d0894bEe39094f1af9,
  SecondaryNav678ea6e8Bfb54fcaB23a4e97f71b84d1,
  ContentSlug875ec4da61f34db7812471c90491003d,
  NavMenuSlug901dbaa6273345ec82a8B0b3a9eea3bc,
  DefaultHeader31faccfdBcef4475B2c1D641bdc1b0f8,
  AboutLevelingPage10caabd74a3543faA8a03cc87e25f717,
  Header565dfaa031ea427787c49d6c83a5380a,
  NavigationAe4ebc2aD87046f0B24a6e9294f8a38b,
  TitleDa1fae35474340a59b3487e6c0afdd7e,
  OmenImageGallery70c25caf152e48eaBbf752f033c4779a,
  Label1efd66b3F63b40ccAaa927bd085fb360,
  MarketingBodyA39ef99c319842569fd8Bb1e1500cfb1,
  FooterA76cb76772a943acBf0dF174671cee77,
  ContentSlug162de8ad46254aeeBf6b8abb57709019,
  OurStoryEa06bfc1C12b41f59560C587c0f175a0,
  Header3189771613df4b0c9967862e1d5855ad,
  ShortHeader4f9e97bdF7ba4870A66bFb3d80b38096,
  Quote0c5a788dB1054d62B6267d86f83f2715,
  Label35cb4e2e79fb4d38A3bd54283e086169,
  EventsButtonDbd7cab6291146fbAa61766d45ee432d,
  ResourcesPageCdf4ed73923948e8B26d665c00d51da6,
  HomeHeader72b710e6Acf64d1d8a2394268d09b1b3,
  NavMenuSlug98ed25f00397488dAf5612797606326f,
  WhyOmenBdd3e1dc6b184afd8972Fe8bc1107de7,
  NavMenuSlug26d002242cdb421dAc72A028a22073b4,
  JoinButton8a7436d257574a1b8a72Dec2de484fc3,
  AboutUsPageD162191f8aee46d8B4e8A81e9a91bbf4,
  Footer3c24d4b730c94e44B3070b28451ef3b7,
  HeaderC26b5246F9a04a5bA321Eb275fcdd63f,
  Header45f9f8c9C4b44888AeacEc5d17dd33a1,
  As1e102fd4825845ab948c0c0fe6b4534d,
  Href3d932f852cde44c19735C4dc6e8908c7,
  MemberPagesCec4bc13E3904eb5Ae0c2027c80ad748,
  WelcomeBack8acea69541a041cc8366F2c7f577444a,
  Header8655273e2de44f44Aaf407a8d3e2cd28,
  Header36f7660bF44843388744151e508a8211,
  NavMenuSlugF62fcbe250334c4dA85eA4ac87f1cd49,
  LabelB4df585bA1c84f528f34A57e772a63c4,
  SecondaryMarketingHeader8aca20333265438fAc457e9bd43ceea1,
  PostSlugBd083fb52f884cff869dF10b9892b8a7,
  Navigation5931d8155c7541c588eeAa1b29427ede,
  HeaderTopEa6fb991D544464bB8da147317734448,
  NavMenuSlugBbbacd7a1d724c05A04816fe840b5636,
  Class04d2a5d34fe54369A34e3f99d883f31e,
  DefaultHeaderTopE752d40187ea4ded95fb0e765a721acd,
  Footer1b4f57e24d274255B6e72c2e51c43706,
  LinkedLogoBfa4bb1cAf41497198ca5d272fa5622f,
  BackgroundImageF21180e889544ca0Ac7eEd2b6ffe568f,
  NavMenuSlugA8883b74D1ad48f78d3b6c2510b0cd61,
  HrefC8ea2f250c7645918260E7624555e3d9,
  SecondaryMarketingHero0b4bf3ff55b6475aA1025ac8cdfb8f84,
  ButtonClass140b05e5C27d4821A1f9Bcef44a3fb98,
  LinksEeaa9ec43b544f79973cAad84414d487,
  GroupflowB068410bB6c54631953b0ab88ec3623c,
  TitleD8a337da21d4435eAa8130637bb192ae,
  Class3bd6025924544589Bae545f28a1b9b82,
  PageQuoteB96404ad685a4554Aaff0f6e5da638ed,
  Footer2158ad416a64442bBc6e4342bc1dd973,
  Footer14db60111c744f24A50933b179cd3f0b,
  Header669c6d639d2f4fd9B0b9A5dd2189f6cd,
  PostSlugA519ee7d146740d88ab0Dfe61569450e,
  Label8f5070754741443bA5c0Dfb118f3ab07,
  MessagePages609d72a22b0b4ad7B8c6390e7ed690e2,
  Header3ff6660f9f6149eaBbf6F840e9f3e4a1,
  LogoDf977f0dC0a145c08d69A193005d293b,
  ContentB4c1c06f744d426f809cDafa48a3bf1d,
  TitleCf66dc863cbe4ec8A53896c83b39de93,
  AdminPages77685f983e324c03Bde0F8e2a132ef2e,
  Alt8f5c0942D56e4e4aA5589ec82b3931b5,
  Title6c9c28bfC47644e99dc80f0c37586926,
  Header1f2eb3804ce34b0eA306A5bf765f71a9,
  ClassCa5b56b1B4a4478f8db3Be53e194ea9c,
  Href86942ecbD85f4cad803791ab055e6f02,
  Header25450764Fa7b4f47A31b94bff0c310c8,
  ImageUrlBf1842c7Adf34abdA606D0941aaa48d1,
  FooterD27d1416F0864ed4Bea9D985b869dedc,
  Title781b995b46f44e60B27b98db192db166,
  SignupPages5411187e679e4dfaA140E28ccc220f93,
  Hero434c22a857f74c7a8aeb539fc915a2e1,
  HeaderTopC18bb6f392d14ba2Afe43b09483ed555,
  TitleF7cbb2652f264c2f8651983df015323f,
  ClassEbd239dd825d4afdA0c32e77c7dfd164,
  ClassNameBcdaceea535941af8fdb99937eca0803,
  TitleAda3f963303644c99081C5b8b966b905
}

export default Components;